import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "min-h-full flex" }

import * as yup from "yup";
import { useField, useForm, FieldContext } from "vee-validate";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import { Auth } from "aws-amplify";
import { computed, onMounted, ref } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'InviteView',
  setup(__props) {

const store = useStore();
const router = useRouter();

const formSchema = yup.object({
  email: yup.string().email().required("必須項目です"),
  password: yup.string(),
  new_password: yup.string(),
});

useForm({ validationSchema: formSchema });

const email_field = useField<string>("email");
const password_field = useField<string>("password");
const new_password_field = useField<string>("new_password");

const email = email_field.value;
const email_error = email_field.errorMessage;

const password = password_field.value;
const password_error = password_field.errorMessage;

const new_password = new_password_field.value;
const new_password_error = new_password_field.errorMessage;

const login_result = ref<any>();
const mode = ref<string>("signin");
const message = ref<string>("");

const facebookSignInUrl = computed<string>(() => {
  return `https://terraspace-prod.auth.ap-northeast-1.amazoncognito.com/oauth2/authorize?identity_provider=Facebook&redirect_uri=http://localhost:8080/oauth/facebook/callback&response_type=CODE&client_id=${process.env.VUE_APP_AWS_COGNITO_CLIENT_ID}`;
});

const googleSignInUrl = computed<string>(() => {
  return `https://terraspace-prod.auth.ap-northeast-1.amazoncognito.com/oauth2/authorize?identity_provider=Google&redirect_uri=http://localhost:8080/oauth/google/callback&response_type=CODE&client_id=${process.env.VUE_APP_AWS_COGNITO_CLIENT_ID}`;
});

const lineSignInUrl = computed<string>(() => {
  return `https://terraspace-prod.auth.ap-northeast-1.amazoncognito.com/oauth2/authorize?identity_provider=LINE&redirect_uri=http://localhost:8080/oauth/facebook/callback&response_type=CODE&client_id=${process.env.VUE_APP_AWS_COGNITO_CLIENT_ID}`;
});

const appleSignInUrl = computed<string>(() => {
  return `https://terraspace-prod.auth.ap-northeast-1.amazoncognito.com/oauth2/authorize?identity_provider=SignInWithApple&redirect_uri=http://localhost:8080/oauth/apple/callback&response_type=CODE&client_id=${process.env.VUE_APP_AWS_COGNITO_CLIENT_ID}`;
});

// 207e41d1-201a-48ea-a548-19bff818d108
onMounted(async () => {
  // console.log('store');
  // console.log(store.state.is_guest, store.state.decedent_id);
  if (store.state.is_guest && store.state.decedent_id) {
    guestLogin(store.state.decedent_id);
  }
});

const validateLogin = async (): Promise<boolean> => {
  await email_field.validate();
  await password_field.validate();

  return !email_error.value && !password_error.value;
};

const doLogin = () => {
  // console.log(`doLogin(${email.value}, ${password.value})`);

  store.dispatch("setLoading", true);
  setTimeout(async () => {
    try {
      const valid = await validateLogin();
      if(!valid) {
        return;
      }

      login_result.value = await Auth.signIn(email.value, password.value);
      // console.log(login_result.value);

      if (login_result.value.challengeName == "NEW_PASSWORD_REQUIRED") {
        mode.value = "new_password";
      }
    } catch (ex) {
      const errorMessage = `${ex}`;
      // console.log(errorMessage);

      if (errorMessage.startsWith("NotAuthorizedException")) {
        message.value = "ログインに失敗しました";
      }
    } finally {
      store.dispatch("setLoading", false);
    }
  });
};

const doComplateNewPassword = () => {
  // console.log(`doComplateNewPassword(${new_password.value})`);

  store.dispatch("setLoading", true);
  setTimeout(async () => {
    try {
      const newpassword_result = await Auth.completeNewPassword(
        login_result.value,
        new_password.value
      );
      // console.log(newpassword_result);
    } finally {
      store.dispatch("setLoading", false);
    }
  });
};

const clearError = () => {
  message.value = "";
};

const guestLogin = (decedent_id) => {
  store.dispatch("markShownVideo", true);
  store.dispatch("setLoading", true);
  setTimeout(async () => {
    try {
      login_result.value = await Auth.signIn(`rimoku@hasema-system.com`, `uyVEaXpaysLV`);
      
      // console.log('/decedents/' + decedent_id);
      router.replace('/decedents/' + decedent_id);

    } catch (ex) {
      const errorMessage = `${ex}`;
      // console.log(errorMessage);

      if (errorMessage.startsWith("NotAuthorizedException")) {
        message.value = "ログインに失敗しました";
      }
    } finally {
      store.dispatch("setLoading", false);
    }
  });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1))
}
}

})